/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingMelcoModelsCustomWarning
 */
export interface TrackingMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function TrackingMelcoModelsCustomWarningFromJSON(json: any): TrackingMelcoModelsCustomWarning {
    return TrackingMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function TrackingMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function TrackingMelcoModelsCustomWarningToJSON(value?: TrackingMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


